import { create } from 'zustand';

export interface AuthUser {
  id: string;
  telegramUserId: string | null;
  primaryEmail: string | null;
  username: string | null;
  firstName: string | null;
  lastName: string | null;
  role: 'user' | 'inhound' | 'editor' | 'admin';
  identities: Array<{
    provider: 'telegram' | 'supabase_email';
    providerSubject: string;
    emailNormalized: string | null;
    telegramUserId: string | null;
    verifiedAt: string | null;
    lastLoginAt: string | null;
  }>;
}

export type SessionMode = 'anonymous' | 'authenticated';
export type AuthRuntime = 'telegram' | 'web';

interface AuthState {
  runtime: AuthRuntime;
  accessToken: string | null;
  user: AuthUser | null;
  sessionMode: SessionMode;
  isAuthenticated: boolean;
  isReady: boolean;

  setRuntime: (runtime: AuthRuntime) => void;
  setAuth: (token: string, user: AuthUser, runtime?: AuthRuntime) => void;
  setSignedOut: (runtime?: AuthRuntime) => void;
  clearAuth: () => void;
}

export const useAuthStore = create<AuthState>((set, get) => ({
  runtime: 'web',
  accessToken: null,
  user: null,
  sessionMode: 'anonymous',
  isAuthenticated: false,
  isReady: false,

  setRuntime: (runtime) =>
    set({
      runtime,
    }),
  setAuth: (token, user, runtime) =>
    set({
      runtime: runtime ?? get().runtime,
      accessToken: token,
      user,
      sessionMode: 'authenticated',
      isAuthenticated: true,
      isReady: true,
    }),
  setSignedOut: (runtime) =>
    set({
      runtime: runtime ?? get().runtime,
      accessToken: null,
      user: null,
      sessionMode: 'anonymous',
      isAuthenticated: false,
      isReady: true,
    }),
  clearAuth: () =>
    set({
      accessToken: null,
      user: null,
      sessionMode: 'anonymous',
      isAuthenticated: false,
      isReady: true,
    }),
}));
